import * as React from "react";
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Bar,
  Tooltip
} from "recharts";

export interface Props {
  data: {}[];
  valueKey: string;
  labelKey: string;
  children?: React.ReactNode;
}

export interface State {}

export default class SimpleBarChart extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <ResponsiveContainer width="100%" height={250}>
        <BarChart syncId="anyId" data={this.props.data}>
          <XAxis dataKey="timeString" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="total" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SimpleBarChart/SimpleBarChart.tsx